// src/redux/reducers/siteReducer.js
import { SET_TIME_RANGE } from "../actions/timerangeAction";

const initialState = {
    timerange: '',
};

const timerangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TIME_RANGE:
      return {
        ...state,
        timerange: action.payload,
      };
    default:
      return state;
  }
};

export default timerangeReducer;
